import CommonQuestions from 'components/CommonQuestions';
import FaqSkeleton from 'components/FaqSkeleton';
import React, { useEffect, useMemo, useState } from 'react'
import { Container, Content, EmptyState, FaqTitle, TherapistsTitle } from './styled';
import useI18n from 'hooks/useI18n';
import { FormSpacer } from 'ui/styled';
import { ReadByUsage } from 'services/faqs';
import { apiRequest, exposeStrapiError } from 'utils';
import { languages } from 'utils/options';

export default function Faq() {
  const [loading, setLoading] = useState(false)
  const [faqSet, setFaqSet] = useState(null)

  const { t, language } = useI18n()

  useEffect(() => {
    const loadFaq = async () => {
      setLoading(true)
      const currentLang = languages?.find(item => item?.id === language)

      const result = await apiRequest(() => ReadByUsage('platform_general', {
        locale: currentLang?.ref
      }))

      if (result && !exposeStrapiError(result)) {
        setFaqSet(result?.data || null)
      } else {
        setFaqSet(null)
      }

      setLoading(false)
    }

    loadFaq()
  }, [language]);

  const faqItems = useMemo(() => faqSet?.items || [], [faqSet]);

  return (
    <>
      <FormSpacer extraLarge />

      <Content>
        <FaqTitle>{t("frequently_asked_questions")}</FaqTitle>
        <TherapistsTitle>{t("faq")}</TherapistsTitle>
        {
          loading ? <FaqSkeleton /> :
            faqItems.length
              ? <CommonQuestions items={faqItems} />
              : <Container><EmptyState>{t("no_faqs_available")}</EmptyState></Container>
        }
      </Content>
    </>

  )
}
